import type { ResourcesConfig } from "aws-amplify";

export interface WitSettings {
  userPoolId: string;
  userPoolClientId: string;
  oauthDomain: string;
  graphqlEndpoint: string;
  graphqlRegion: string;
}

export async function loadSettings(): Promise<WitSettings> {
  const response = await fetch("/settings.json", { cache: "no-store" });
  if (!response.ok) {
    throw new Error(`Failed to load /settings.json: ${response.status}`);
  }
  return response.json();
}

export function buildAmplifyConfig(settings: WitSettings, origin: string): ResourcesConfig {
  return {
    Auth: {
      Cognito: {
        userPoolId: settings.userPoolId,
        userPoolClientId: settings.userPoolClientId,
        loginWith: {
          oauth: {
            domain: settings.oauthDomain,
            scopes: ["openid"],
            redirectSignIn: [origin],
            redirectSignOut: [origin],
            responseType: "code",
          },
        },
      },
    },
    API: {
      GraphQL: {
        endpoint: settings.graphqlEndpoint,
        region: settings.graphqlRegion,
        defaultAuthMode: "userPool",
      },
    },
  };
}
